import { Deck } from '../searchEngine/types';
import { decksCollection } from '../utils/storage';
import { auth, db } from './firebase'
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, serverTimestamp, updateDoc, where } from "firebase/firestore";

export async function saveDeck(deck: Deck) {
  if (deck.id) editDeck(deck)
  else createDeck(deck)
}

export async function createDeck(deck: Deck) {
    try {
      const user = auth.currentUser
      if (!user) throw Error("Usuário não autenticado!")

      const decksRef = collection(db, decksCollection);

      await addDoc(decksRef, {
        ...deck,
        userId: user.uid,
        created: serverTimestamp(),
      });
    } catch (error) {
      console.error("Erro ao adicionar documento:", error);
    }
}

export async function editDeck(deck: Deck) {
    try {
      const user = auth.currentUser
      if (!user) throw Error("Usuário não autenticado!")
      if (!deck.id) throw Error("Deck não existe!")

      const docRef = doc(collection(db, decksCollection), deck.id);
      await updateDoc(docRef, deck);

    } catch (error) {
      console.error("Erro ao editar documento:", error);
    }
}

export async function deleteDeck(deckId: string) {
    try {
      const user = auth.currentUser
      if (!user) throw Error("Usuário não autenticado!")
      if (!deckId) throw Error("Deck não existe!")

      const docRef = doc(collection(db, decksCollection), deckId);
      await deleteDoc(docRef);

    } catch (error) {
      console.error("Erro ao excluir documento:", error);
    }
}

export async function getAllUserDecks(): Promise<Deck[]> {
  if (!auth.currentUser)
		throw new Error('User not authenticated')

  const savedDecks: Deck[] = []

	const querySnapshot = await getDocs(query(collection(db, decksCollection), where("userId", "==", auth.currentUser.uid)));

	querySnapshot.forEach((doc) => savedDecks.push({ ...doc.data(), id: doc.id } as Deck));

  return savedDecks;
}

export const getUserDeckById = async (id: string): Promise<Deck> => {
  const docRef = doc(db, decksCollection, id);
  const deck = await getDoc(docRef);
  return { ...deck.data(), id: deck.id } as Deck
}